PJQ.views.invoicing.InvoiceSummary = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'invoice-summary')
    },
    events: {
        'click .btn-export-summary': 'export'
    },
    beforeFirstRender: function () {
        this.summary = {}
        this.model.getSummary(_.bind(function (summary) {
            if (summary != null) {
                this.summary = summary;
                this.render();
            } else {
                this.render();
            }
        }, this))
    },
    renderData: function () {
        return {
            summary: this.summary,
            project: PJQ.app.session.project,
            model: this.model
        }
    },
    export: function () {
        if (typeof this.options.export === 'function') {
            this.options.export(this.model);
        }
    }
});